import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["src", "alt", "width", "height"];
import { ref, computed, onMounted } from 'vue';
import { getOptimizedImageUrl } from '@shared/utils/imageOptimization';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LazyImage',
    props: {
        lazy: { type: Boolean, default: true },
        optimized: { type: Boolean, default: true },
        quality: { default: 80 },
        src: {},
        alt: {},
        width: {},
        height: {},
        className: {},
        placeholder: { default: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y3ZjdmNyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0ibW9ub3NwYWNlIiBmb250LXNpemU9IjE0cHgiIGZpbGw9IiNjY2MiPkxhZGUuLi48L3RleHQ+PC9zdmc+' }
    },
    setup(__props) {
        const props = __props;
        const isLoading = ref(true);
        const hasError = ref(false);
        const imageSrc = ref('');
        const placeholderStyle = computed(() => ({
            width: props.width ? `${props.width}px` : '100%',
            height: props.height ? `${props.height}px` : '200px'
        }));
        const loadImage = () => {
            if (props.optimized) {
                imageSrc.value = getOptimizedImageUrl(props.src, {
                    width: props.width,
                    height: props.height,
                    quality: props.quality,
                    format: 'webp'
                });
            }
            else {
                imageSrc.value = props.src;
            }
        };
        const onImageLoad = () => {
            isLoading.value = false;
            hasError.value = false;
        };
        const onImageError = () => {
            isLoading.value = false;
            hasError.value = true;
            console.warn(`Failed to load image: ${props.src}`);
        };
        onMounted(() => {
            if (!props.lazy) {
                loadImage();
                return;
            }
            // Intersection Observer for lazy loading
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        loadImage();
                        observer.disconnect();
                    }
                });
            }, { threshold: 0.1 });
            const element = document.querySelector('.lazy-image-container');
            if (element) {
                observer.observe(element);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["lazy-image-container", { 'loading': isLoading.value }])
            }, [
                (!isLoading.value && imageSrc.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: imageSrc.value,
                        alt: _ctx.alt,
                        class: _normalizeClass(_ctx.className),
                        width: _ctx.width,
                        height: _ctx.height,
                        onLoad: onImageLoad,
                        onError: onImageError
                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Loading Placeholder "),
                (isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "image-placeholder",
                        style: _normalizeStyle(placeholderStyle.value)
                    }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("div", { class: "placeholder-content" }, [
                                _createElementVNode("i", { class: "fas fa-spinner fa-spin" }),
                                _createElementVNode("span", { class: "sr-only" }, "Lädt...")
                            ], -1 /* CACHED */)
                        ]))], 4 /* STYLE */))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Error State "),
                (hasError.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "image-error",
                        style: _normalizeStyle(placeholderStyle.value)
                    }, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("div", { class: "error-content" }, [
                                _createElementVNode("i", { class: "fas fa-exclamation-triangle" }),
                                _createElementVNode("span", { class: "text-sm" }, "Bild konnte nicht geladen werden")
                            ], -1 /* CACHED */)
                        ]))], 4 /* STYLE */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
